<template lang="pug">
  div(style='position: absolute; left:0px; top:0px; background-color: rgba(0,255,0,0.5)')
    div.slot.pbc-z-level-1(:style='style')
      .absolute
        slot(name="default",v-bind:alignment='alignment')
</template>
<script>
export default {
  props:{
    bounds:{
      type:Object,
      required:true
    },
    position:{
      type:String,
      default:'center'
    }
  },
  computed:{
    width() {
      return Math.max(60, Math.max(
        Math.abs(this.bounds.p3.x - this.bounds.p1.x),
        Math.abs(this.bounds.p4.x - this.bounds.p2.x)
      ))

    },
    height() {
      return Math.max(60, Math.max(
        Math.abs(this.bounds.p3.y - this.bounds.p1.y),
        Math.abs(this.bounds.p4.y - this.bounds.p2.y)
      ))

    },
    style() {
      const width = this.width; 
      const height = this.height;

      let pos;
      if (this.alignment === "center") {
        pos = {
          x:(this.bounds.p1.x + this.bounds.p3.x)/2,
          y:(this.bounds.p1.y + this.bounds.p3.y)/2
        }
      } else if (this.alignment === "bottom") {
        pos = {
          x:(this.bounds.p1.x + this.bounds.p3.x)/2,
          y:(this.bounds.p1.y + this.bounds.p3.y)/2 + height/2
        }
      } else if (this.alignment === "top") {
        pos = {
          x:(this.bounds.p1.x + this.bounds.p3.x)/2,
          y:(this.bounds.p1.y + this.bounds.p3.y)/2 - height/2
        }
      }
      return {
        position:'relative',
        opacity:1.0,
        left:pos.x + 'px',
        'background-color':'rgba(255,0,0,0.3)',
        top:pos.y + 'px',
      }
    },
    alignment() {
      if (this.position !== 'auto') {
        return this.position;
      }

      const center = {
        x:(this.bounds.p1.x + this.bounds.p3.x)/2,
        y:(this.bounds.p1.y + this.bounds.p3.y)/2
      }
      if (center.y > (window.innerHeight-96)/2) {
        return "top";
      } else {
        return "bottom";
      }

    }
  }
}
</script>
